import { Box, Button, Card, CardContent, CardHeader } from "@mui/material";
import type { Widget } from "./types";

interface ActionItem {
  label: string;
  icon?: string;
  action?: string;
}

export function ActionsCard({ widget }: { widget: Widget }) {
  const items = ((widget.config?.items as ActionItem[] | undefined) ?? []).filter(
    (it) => it && typeof it === "object" && typeof it.label === "string",
  );
  return (
    <Card variant="outlined">
      {widget.title && (
        <CardHeader
          title={widget.title}
          titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
          sx={{ pb: 1 }}
        />
      )}
      <CardContent sx={{ pt: 0 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {items.map((it, i) => (
            <Button key={i} variant="outlined" size="small">
              {it.label}
            </Button>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
